import React from "react";

type Props = {};

const NotFound = (props: Props) => {
  return <div>잘못된 접근입니다.</div>;
};

export default NotFound;
